<style scoped lang="scss">
@import "../mobile";
.wrap-search{
  .order-lists{
    li{
      box-shadow: 0 0 10px rgba(0,0,0,.07);
    }
  }
}
</style>
<template>
  <div class="wrap-app wrap-search">
    <qk-search-bar @search="getOrders"/>
    <div class="order">
      <ul class="order-lists">
        <li v-for="item in orderLists" :key="item.value.id" @click="toDetails(item.value.id)">
          <div class="top">
            <div>订单号：<span class="text-primary">{{item.value.no}}</span></div>
            <span class="status status-primary">{{item.value.statusName}}</span>
          </div>
          <div class="con">
            <div class="title">项目名称：{{item.value.name}}</div>
            <div class="price">应付金额：￥{{item.value.amount | amount}}<span class="fr">{{item.value.createTime | rTime}}</span></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="search-empty" v-show="orderLists.length === 0 && isSearch">
      <img src="@/assets/images/mobile/empty.png">
      <p>没有搜到内容哦~</p>
    </div>
  </div>
</template>

<script>
import { project } from '@/services/api.index'
export default {
  data () {
    return {
      orderLists: [],
      page: 0,
      pageSize: 10,
      isSearch: false
    }
  },
  created() {
    const orderNo = localStorage.getItem('searchKeywords')
    if (!this.baseMethods.isEmpty(orderNo)) {
      this.getOrders(orderNo)
    }
  },
  methods: {
    getOrders (orderNo) {
      const { page, pageSize } = this
      const memberInfo = this.baseMethods.getLocalObj('memberInfo')
      project(page, pageSize, orderNo, '', '', '', memberInfo.id).then((res) => {
        this.isSearch = true
        res.data.list.map(item => {
          item.value.statusName = this.baseMethods.orderStatus(item.value.orderStatus)
        })
        this.orderLists = res.data.list
        localStorage.setItem('searchKeywords', orderNo)
      })
    },
    // 跳转到详情页
    toDetails (id) {
      this.$router.push(`/other/order_details?id=${id}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/other/search.vue